import { render, staticRenderFns } from "./downgrade_rules.vue?vue&type=template&id=793e4962&scoped=true"
import script from "./downgrade_rules.vue?vue&type=script&lang=js"
export * from "./downgrade_rules.vue?vue&type=script&lang=js"
import style0 from "./downgrade_rules.vue?vue&type=style&index=0&id=793e4962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793e4962",
  null
  
)

export default component.exports